import { ExpandMore } from '@mui/icons-material';
import { Fragment, memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import AccordionRecapForm from './form';
import { FormikProps } from 'formik';
import { FormRecapVM } from 'practice/view-models/pratice-recap';
import { TypeRegister } from 'practice/constants/type-register';

interface StepRecapProps {
  codeEnte?: string;
  yearId?: string;
  typeRegister?: string;
  progressive?: string;
  typePractice?: string;
  identifierAnpr?: string;
  formContext: FormikProps<FormRecapVM>;
  setDisabledForward: (disabled: boolean) => void;
  onSubmit: (values: FormRecapVM) => void;
  disabled?: boolean;
  fromPerson?: string;
  ForPracticeTemporary?: boolean;
}

const AccordionRecapComponent = ({
  codeEnte,
  yearId,
  typePractice,
  typeRegister,
  progressive,
  identifierAnpr,
  formContext,
  setDisabledForward,
  onSubmit,
  disabled,
  fromPerson,
}: StepRecapProps): React.ReactElement => {
  const [open, setOpen] = useState(true);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-recap-content"
          id="panel-recap-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>
            {typeRegister === TypeRegister.Immigration || typeRegister === TypeRegister.Residence
              ? 'Domanda di apertura'
              : 'Riepilogo'}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <AccordionRecapForm
            codeEnte={codeEnte}
            yearId={yearId}
            typeRegister={typeRegister}
            progressive={progressive}
            typePractice={typePractice}
            identifierAnpr={identifierAnpr}
            formContext={formContext}
            setDisabledForward={setDisabledForward}
            onSubmit={onSubmit}
            disabled={disabled}
            fromPerson={fromPerson}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionRecapComponent.displayName = 'Accordion Recap';

const AccordionRecap = memo(AccordionRecapComponent);

export default AccordionRecap;
